module.exports = __webpack_public_path__ + "html/video-container.component.html";